import { useEffect, useRef } from "react";

// Anti-spam for the public forms: a Cloudflare Turnstile check (invisible
// unless Cloudflare has doubts) plus a honeypot field people never see.
// Turnstile only renders once REACT_APP_TURNSTILE_SITE_KEY is set at build.
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
let scriptPromise;
const loadScript = () =>
  (scriptPromise ||= new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  }));

// `resetKey` changes after every submit: tokens are single-use.
export function Turnstile({ onToken, lang, resetKey }) {
  const ref = useRef(null);
  const cb = useRef(onToken);
  cb.current = onToken;

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let id;
    let cancelled = false;
    cb.current("");
    loadScript()
      .then(() => {
        if (cancelled || !ref.current) return;
        id = window.turnstile.render(ref.current, {
          sitekey: SITE_KEY,
          language: lang,
          appearance: "interaction-only",
          callback: (t) => cb.current(t),
          "expired-callback": () => cb.current(""),
          "error-callback": () => cb.current(""),
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (id !== undefined) window.turnstile?.remove(id);
    };
  }, [lang, resetKey]);

  if (!SITE_KEY) return null;
  return <div ref={ref} />;
}

export function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
      <label>
        Website
        <input type="text" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
      </label>
    </div>
  );
}
